<template>
<div>
    <!-- modal -->
    <b-modal id="lawAuthorityFormModal" centered size="lg" no-close-on-backdrop ref="lawAuthorityFormModal" :title=" $t('lawAuthority.info')" :cancel-title=" $t('others.cancel_title')" :ok-title=" $t('others.ok_title')" cancel-variant="outline-secondary" @ok.prevent="addOrUpdate">
        <validation-observer ref="simpleRules">
        <b-row>
            <b-col class="col-lg-6">
                            <b-form-group>
                                    <label>{{ $t('lawAuthority.law_authority_type_name')  }}</label>
                                    <validation-provider v-slot="{ errors }" :name="$t('lawAuthority.law_authority_type_name')" :rules="{ excluded:0}" >
                                    <b-form-select size="sm" v-model="lawAuthorityTypeSelect" value-field="id" text-field="name" :options="lawAuthorityTypeList" :state="errors.length > 0 ? false:null" />
                                        <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>
            </b-col>
            <b-col class="col-lg-6" >
                <b-form>
                <label>{{ $t('lawAuthority.type') }}</label>
                <b-form-group>
                    <validation-provider #default="{ errors }" :name=" $t('lawAuthority.type')" rules="required">
                        <b-form-input v-model="name" size="sm" maxlength="250" :state="errors.length > 0 ? false:null" />
                        <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                </b-form-group>
            </b-form>
            </b-col>
        </b-row>
        <b-row>
                   <b-col class="col-lg-12">
                        <label>{{ $t('lawAuthority.note') }}</label>
                        <b-form-textarea :placeholder=" $t('lawAuthority.note')" rows="3" v-model="note" maxlength="250" />
                    </b-col>
            </b-row>
        </validation-observer>
    </b-modal>
</div>
</template>

<script>
export default {
    props: {
        getLawAuthorityList: {
            type: Function
        },
    },
    data() {
        return {
            id: 0,
            name: '',
            lawAuthorityTypeList: [],
            lawAuthorityTypeSelect: 0,
            note: ''
        }
    },
    methods: {
        async showInfo(id) {
            this.$refs['lawAuthorityFormModal'].show()
            this.id = id

            const data = {id: this.id }
            const controller = {  name: 'LawAuthority'}
            const payload = { data: data,controller: controller  }

            const response = await this.$store.dispatch('moduleAuth/getInfo', payload)
                if (response.data.resultStatus == true) {
                    this.lawAuthorityTypeList = response.data.lawAuthorityTypeList
                    this.lawAuthorityTypeList.splice(0, 0, this.$nullSelected())
                    this.lawAuthorityTypeSelect = response.data.lawAuthority.lawAuthorityTypeId
                    this.name = response.data.lawAuthority.name
                    this.note = response.data.lawAuthority.note
                } else {
                    this.$bvModal.hide('lawAuthorityFormModal')
                    this.$WarningAlert(response.data.resultMessage)
                }
           
        },
        async addOrUpdate() {

            const data = {id: this.id, name: this.name, lawAuthorityTypeId: this.lawAuthorityTypeSelect,note: this.note}
            const controller = {name: 'LawAuthority' }
            const payload = {  data: data, controller: controller }

            const success = await this.$refs.simpleRules.validate()
                if (success) {
                    const response = await this.$store.dispatch('moduleAuth/save', payload)
                        if (response.data.resultStatus == true) {
                            this.$bvModal.hide('lawAuthorityFormModal')
                            this.getLawAuthorityList()
                            this.$SaveAlert()
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                        }
                }
        }
    }
}
</script>
  
<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}
</style>
